import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { showLoader, hideLoader } from "./loaderSlice";

const FULFILLMENT_PORT = "10460";
const environment = process.env.REACT_APP_ENV;
const FULFILLMENT_HOST =
  environment === "production" || environment === "prod"
    ? "https://demo.order2ucloud.com"
    : `https://demo.${environment}.order2ucloud.com`;
const FULFILLMENT_BASE_URL = `${FULFILLMENT_HOST}:${FULFILLMENT_PORT}/`;

const dynamicBaseQuery = async (args, api, extraOptions) => {
  const rawBaseQuery = fetchBaseQuery({
    baseUrl: FULFILLMENT_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      headers.set("Content-Type", "application/json");
      const token = getState().auth.token;
      if (token) {
        headers.set("jwtToken", token);
      }
      return headers;
    },
  });

  return rawBaseQuery(args, api, extraOptions);
};

export const customFulfillmentSlice = createApi({
  reducerPath: "customFulfillmentApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["CustomFulfillment"],
  endpoints: (builder) => ({
    searchCustomFulfillment: builder.mutation({
      query: (searchPayload) => ({
        url: "v1/custom/getOrderList",
        method: "POST",
        body: searchPayload,
      }),
      onQueryStarted: async (arg, { dispatch }) => {
        dispatch(showLoader());
        return () => dispatch(hideLoader());
      },
      invalidatesTags: ["CustomFulfillment"],
    }),
    pushCustomFulfillmentOrder: builder.mutation({
      query: (payload) => ({
        url: `${FULFILLMENT_HOST}/orderShipmentWriteService/customFulfillmentOrderPush`,
        method: "POST",
        body: payload,
      }),
      onQueryStarted: async (arg, { dispatch }) => {
        dispatch(showLoader());
        return () => dispatch(hideLoader());
      },
      invalidatesTags: ["CustomFulfillment"],
    }),
  }),
});

export const {
  useSearchCustomFulfillmentMutation,
  usePushCustomFulfillmentOrderMutation,
} = customFulfillmentSlice;
